import React, { ReactNode } from 'react';
import { SanitySiteSettings } from '../../types/common';

type SEOProps = {
  data: {
    seo: {
      metaTitle: string;
      metaDescription?: string;
    }
  }
  settings?: SanitySiteSettings | null;
  children?: ReactNode;
}

export function SEO({ data, settings, children }: SEOProps) {
  return (
    <>
      <html lang={settings?.language ?? 'en'} />
      <title>{data.seo.metaTitle}</title>
      <meta name="description" content={data.seo.metaDescription} />
      {children}
    </>
  );
}
